import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const MessageNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="#007EFC" />
    <Circle cx={12} cy={12} r={12} fill="url(#MessageNotification1)" />
    <Circle cx={12} cy={12} r={12} fill="url(#MessageNotification2)" />
    <Path
      d="M12.644 9.083H9.606c-.123 0-.242.005-.355.02-1.277.108-1.918.86-1.918 2.246v1.892c0 1.892.76 2.266 2.273 2.266h.19c.105 0 .242.07.304.151l.57.757c.251.336.66.336.91 0l.57-.757a.382.382 0 0 1 .304-.151h.19c1.39 0 2.145-.634 2.254-1.911.014-.114.019-.232.019-.355v-1.892c0-1.509-.76-2.266-2.273-2.266Zm-3.175 3.784a.472.472 0 1 1 0-.946c.26 0 .474.213.474.473s-.213.473-.474.473Zm1.656 0a.472.472 0 1 1 0-.946.472.472 0 1 1 0 .946Zm1.661 0a.472.472 0 1 1 0-.946c.261 0 .475.213.475.473s-.214.473-.475.473Z"
      fill={color}
    />
    <Path
      d="M16.667 9.49v1.8c0 .9-.283 1.512-.849 1.849-.136.081-.296-.027-.296-.184l.005-1.666c0-1.8-1.044-2.83-2.868-2.83l-2.777.004c-.16 0-.27-.158-.187-.293.342-.558.962-.837 1.87-.837h2.918c1.454 0 2.184.72 2.184 2.156Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="MessageNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#22B4FD" />
        <Stop offset="1" stopColor="#0465E1" />
      </LinearGradient>
      <LinearGradient
        id="MessageNotification2"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#72E78D" />
        <Stop offset="1" stopColor="#1FB543" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default MessageNotification;
